// extracted by mini-css-extract-plugin
export default {"container":"Layout_container__DZ+25","mainContent":"Layout_mainContent__R6hOL"};